import React from "react";
import SkeletonCard from "./SkeletonCard";
import "./skeleton.css";

/**
 * SkeletonGrid — Renders a responsive grid of SkeletonCard placeholders.
 * Uses the same Tailwind grid classes as the real product grids.
 *
 * @param {Object} props
 * @param {number}  [props.count=8]       - Number of skeleton cards to render
 * @param {string}  [props.columns]       - Custom Tailwind grid classes
 * @param {string}  [props.gap]           - Custom Tailwind gap classes
 */
export default function SkeletonGrid({
    count = 8,
    columns = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
    gap = "gap-3 sm:gap-6",
}) {
    return (
        <div
            className={`grid ${columns} ${gap}`}
            aria-busy="true"
            aria-label="Chargement en cours"
            role="status"
        >
            {Array.from({ length: count }, (_, i) => (
                <SkeletonCard key={i} index={i} />
            ))}
        </div>
    );
}
